import Axios from "axios";
import { SETTINGS } from "../properties/Settings";

export const CarrierRepository = {
  getAllCarriers: () => {
    return Axios({
      url: `${SETTINGS.API_URL}carrier/all`,
      method: "GET",
    });
  },

  getAllByOrganization: (orgId, type) => {
    return Axios({
      url: `${SETTINGS.API_URL}carrier/allByOrganization`,
      params: { organizationId: orgId, type: type },
      method: "GET",
    });
  },
  create: (carrier) => {
    return Axios({
      url: `${SETTINGS.API_URL}carrier`,
      method: "POST",
      data: carrier,
    });
  },

  update: (carrier) => {
    return Axios({
      url: `${SETTINGS.API_URL}carrier`,
      method: "PUT",
      data: carrier,
    });
  },

  deactivate: (id) => {
    return Axios({
      url: `${SETTINGS.API_URL}carrier/deactivate/${id}`,
      method: "PUT",
    });
  },

  search: (args = {}) => {
    const {
      page = 0,
      size = 10,
      sort = "name,asc",
      name,
      eori,
      clientId,
      organizationId, // if provided, takes precedence over clientId
      type,
    } = args;

    // Parse sort -> orderBy / orderDirection
    const [orderByRaw, dirRaw] = String(sort).split(",");
    const orderBy = (orderByRaw || "dateCreated").trim();
    const orderDirection =
      (dirRaw || "ASC").toUpperCase() === "DESC" ? "DESC" : "ASC";

    // Build filter payload with only non-empty keys
    const filters = {};
    if (name && name.trim()) filters.name = name.trim();
    if (eori && eori.trim()) filters.eori = eori.trim();
    if (type) filters.type = type.toUpperCase();

    // Controller receives a generic HashMap, but your codebase commonly uses "organizationId"
    const orgId = organizationId || clientId;
    if (orgId) filters.organizationId = orgId;

    const searchParams = JSON.stringify(filters); // controller expects stringified JSON

    return Axios({
      url: `${SETTINGS.API_URL}carrier`,
      method: "GET",
      params: {
        page,
        size,
        orderBy,
        orderDirection,
        searchParams,
      },
    });
  },
};
